export const deleteChannelFailed = {
  title: '操作できません。カスタマーセンターまでご連絡ください。',
};
